<template>
    <section class="fullscreen content-layer">
        
        <component class="contentcomponent" v-if="layerContent && layerContent.component" 
            :is="layerContent.component"
            :settings="settings"
            :structure="structure"
            :content="content"
            :level="level"
            :layer="layer"
            :navigationData="navigationData"
            :active="active" />

        <video ref="video" v-if="layerContent && layerContent.video"
            :src="layerContent.video.src"
            :loop="layerContent.video.loop" preload="auto" muted
            playsinline
            @timeupdate="onVideoTimeupdate"
            @ended="onVideoEnded"></video>
    </section>
</template>

<script>

import navigationMixin from '@/core/mixins/navigationMixin.js'
import { EventBus } from "@/core/utilities/event-bus.js"

export default {
    data: () => {
        return {
            oldKeyframe: false
        }
    },
    mixins: [navigationMixin],
    props: ['active', 'content', 'layer', 'level', 'structure', 'navigationData', 'settings'],
    watch: {
        active(val) { 
            this.onActivated()
        }, 
        navigationData(data) {
            if (!this.isMainContent || !this.$refs.video) return
            if (this.active) {
                if (data.paused) {
                    this.playPauseVideo(false)
                } else {
                    this.playPauseVideo(true)
                }
            } else {
                this.playPauseVideo(false)
            }
        }
    },
    computed: {
        layerContent() {
            return this.content[this.layer]
        },
        isMainContent() {
            if (!this.isMainContentType) return false
            if (this.level === 'keyframe') return true
            
            return !(this.content.keyframes && this.content.keyframes.length)
        },
        isMainContentType() {
            return this.layer === 'content' && (this.level === 'slide' || this.level === 'keyframe')
        },
        hasVideoContent() {
            return this.layerContent && this.layerContent.video
        }
    },
    methods: {
        onActivated() {
            this.playPauseVideo(true, 0)
        },
        onVideoTimeupdate(e) {
            if (!this.isMainContent || !this.$refs.video || !this.active) return
            let time = Math.round(this.$refs.video.currentTime * 1000)
            let totalTime = Math.round(this.$refs.video.duration * 1000)
            EventBus.$emit('contentProgress', {
                level: this.level,
                time, totalTime
            })
        },
        gotoAndStop(ms) {
            if (!this.isMainContent || !this.active) return
            this.playPauseVideo(false, ms)
        },
        gotoAndPlay(ms) {
            if (!this.isMainContent || !this.active) return
            this.playPauseVideo(true, ms)
        },
        onVideoEnded(val) {
            if (this.isMainContent && this.hasVideoContent && this.active) {
                if (this.layerContent.video.continueOnEnd) {
                    this.$router.push(this.navigationData.nextRoute).catch(err => {})
                } else {
                    EventBus.$emit('videoEnded')
                }
            }
        },
        playPauseVideo(play, ms = false) {
            if (play) {
                if (this.hasVideoContent) {
                    if (ms !== false) this.$refs.video.currentTime = ms / 1000
                    let promise = this.$refs.video.play()
                    if (promise !== undefined) promise.catch(e => {})
                }
            } else {
                if (this.hasVideoContent) {     
                    if (ms !== false) this.$refs.video.currentTime = ms / 1000
                    this.$refs.video.pause()
                }
            }
        },
        setContentProperties() {
            if (!this.layerContent) return
            if (this.layerContent.image) {
                this.$el.style.backgroundImage = `url(${this.layerContent.image.src})`
                if (this.layerContent.image.size) {
                    this.$el.style.backgroundSize = `url(${this.layerContent.image.size})`
                }
            }
            if (this.layerContent.video && this.layerContent.video.poster) {
                this.$el.style.backgroundImage = `url(${this.layerContent.video.poster})`
            }
            if (this.layerContent.color) {
                this.$el.style.backgroundColor = this.layerContent.color
            }
        }
    },
    created() {},
    mounted() {
        this.playPauseVideo(this.active)
        this.setContentProperties()
    }
}
</script>

<style lang="scss">
    
    @import '~@/core/assets/scss/_variables.scss';
    @import '~@/demo/assets/scss/main.scss';

</style>